<template>
  <div class="main-layout">
    <navbar v-if="navbarActive"/>

    <main class="py-4">
      <child/>
    </main>
  </div>
</template>

<script>
import get from 'lodash/get';
import has from 'lodash/has';
import Navbar from '@/components/Navbar.vue';

export default {
  components: {Navbar},

  computed: {
    /**
     * Will activate navbar or not.
     *
     * @return {boolean}
     */
    navbarActive() {
      return !has(this.$route.meta, ['disable_navbar']) || get(this.$route.meta, ['disable_navbar'], true) === false;
    }
  }
}
</script>
